import { render, staticRenderFns } from "./VideoClassroomIcon.vue?vue&type=template&id=6d336210"
import script from "./VideoClassroomIcon.vue?vue&type=script&lang=js"
export * from "./VideoClassroomIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports